var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElectricalServiceUpgradeOrangeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.083 13.3673C28.9974 13.3673 28.1182 12.488 28.1182 11.4024V2.65102C28.1182 1.56534 28.9974 0.686157 30.083 0.686157C31.1662 0.686157 32.0453 1.56541 32.0453 2.65102V11.4024C32.0453 12.4881 31.1661 13.3673 30.083 13.3673Z",
    fill: "url(#paint0_linear_34855_4094)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7524 19.0151C43.2325 19.0151 42.733 18.8087 42.3635 18.4391C41.5989 17.672 41.5989 16.431 42.3635 15.6639L46.5481 11.4742C47.3152 10.7096 48.5588 10.7096 49.3259 11.4792C50.093 12.2464 50.0905 13.49 49.3234 14.2571L45.1133 18.4595C44.7489 18.8137 44.2596 19.0125 43.7524 19.0151L43.7524 19.0151Z",
    fill: "url(#paint1_linear_34855_4094)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1694 32.708H49.4233C48.3401 32.708 47.4609 31.8287 47.4609 30.7457C47.4609 29.66 48.3402 28.7808 49.4233 28.7808H58.1694C59.2526 28.7808 60.1318 29.6601 60.1318 30.7457C60.1318 31.8288 59.2525 32.708 58.1694 32.708Z",
    fill: "url(#paint2_linear_34855_4094)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9631 50.5976C47.4356 50.6052 46.9233 50.3963 46.5513 50.0216L42.3666 45.8523C41.5995 45.0852 41.597 43.8416 42.3641 43.0745C43.1312 42.3049 44.3748 42.3049 45.1419 43.0694L49.352 47.2795C49.9126 47.8401 50.0808 48.6837 49.7776 49.4176C49.4718 50.1516 48.7582 50.6307 47.9631 50.6307L47.9631 50.5976Z",
    fill: "url(#paint3_linear_34855_4094)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1911 50.5977C11.3959 50.5977 10.6824 50.1186 10.3766 49.3847C10.0733 48.6532 10.2415 47.8071 10.8022 47.2465L15.0046 43.0364C15.369 42.6465 15.8736 42.4223 16.4062 42.4121C16.9389 42.4044 17.4537 42.6109 17.8308 42.988C18.208 43.3652 18.4144 43.8775 18.4043 44.4101C18.3966 44.9427 18.1698 45.4499 17.7799 45.8117L13.5774 50.0218C13.2105 50.3913 12.711 50.5977 12.1911 50.5977L12.1911 50.5977Z",
    fill: "url(#paint4_linear_34855_4094)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7329 32.708H1.98146C0.895788 32.708 0.0166016 31.8287 0.0166016 30.7457C0.0166016 29.66 0.895853 28.7808 1.98146 28.7808H10.7329C11.816 28.7808 12.6952 29.6601 12.6952 30.7457C12.6952 31.8288 11.8159 32.708 10.7329 32.708Z",
    fill: "url(#paint5_linear_34855_4094)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3955 19.0161C15.873 19.0161 15.3735 18.8097 15.0066 18.4402L10.8041 14.2454C10.037 13.4783 10.0345 12.2347 10.8016 11.465C11.5687 10.6979 12.8123 10.6954 13.5794 11.4625L17.7819 15.6649C18.549 16.432 18.549 17.6731 17.7819 18.4402C17.4149 18.8097 16.9154 19.0161 16.3955 19.0161L16.3955 19.0161Z",
    fill: "url(#paint6_linear_34855_4094)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0805 60.6861C28.9974 60.6861 28.1182 59.8069 28.1182 58.7213V49.9777C28.1182 48.892 28.9974 48.0128 30.0805 48.0128C31.1662 48.0128 32.0453 48.8921 32.0453 49.9777V58.7213C32.0453 59.8069 31.1661 60.6861 30.0805 60.6861Z",
    fill: "url(#paint7_linear_34855_4094)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6904 30.6865C37.6904 31.1376 37.5324 31.5734 37.247 31.9225C37.2113 31.9786 37.1654 32.0295 37.1145 32.0729L25.8174 43.3778C25.0426 44.071 23.8627 44.0379 23.1262 43.3065C22.3897 42.5751 22.3489 41.3951 23.037 40.6153L30.9885 32.6487H24.4442C23.6491 32.6487 22.9355 32.1696 22.6323 31.4356C22.3265 30.7042 22.4947 29.8606 23.0553 29.2975L34.34 17.9925C35.1097 17.228 36.3533 17.228 37.1204 17.9976C37.885 18.7647 37.885 20.0083 37.1153 20.7754L29.169 28.7218H35.7159C35.8408 28.7243 35.9657 28.7345 36.088 28.7549C37.0182 28.9282 37.6935 29.7412 37.691 30.6866L37.6904 30.6865Z",
    fill: "url(#paint8_linear_34855_4094)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_34855_4094",
    x1: 31.0297,
    y1: 3.95081,
    x2: 22.7231,
    y2: 7.22966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_34855_4094",
    x1: 47.8026,
    y1: 12.9902,
    x2: 40.2441,
    y2: 22.6197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_34855_4094",
    x1: 56.8549,
    y1: 29.7918,
    x2: 55.1255,
    y2: 36.9038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_34855_4094",
    x1: 47.8224,
    y1: 44.5907,
    x2: 40.2464,
    y2: 54.2501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_34855_4094",
    x1: 16.2899,
    y1: 44.5192,
    x2: 8.66312,
    y2: 54.2299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_34855_4094",
    x1: 9.41629,
    y1: 29.7918,
    x2: 7.68787,
    y2: 36.9042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_34855_4094",
    x1: 16.2547,
    y1: 12.9808,
    x2: 8.68449,
    y2: 22.6322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_34855_4094",
    x1: 31.0297,
    y1: 51.2755,
    x2: 22.7245,
    y2: 54.5558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_34855_4094",
    x1: 33.7592,
    y1: 24.231,
    x2: 9.56447,
    y2: 41.9618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricalServiceUpgradeOrangeIcon);
export default __webpack_public_path__ + "static/media/electrical_service_upgrade_orange_icon.1101953a5ae0b5eec3c881bc80822c9d.svg";
export { ForwardRef as ReactComponent };